export const normalizeId = (id) => id?.toUpperCase() ?? null;
export const sameId = (first, second) => {
    if (first == null || second == null)
        return first === second;
    return normalizeId(first) === normalizeId(second);
};
